(() => {
  if (window.knoxPdfDownloadReady) return;
  window.knoxPdfDownloadReady = true;
  document.addEventListener('click', async (event) => {
    const link = event.target.closest('a[download]');
    if (!link || !link.closest('.knoxone-forms-latest, .knox-policy-page') || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const url = new URL(link.href);
    if (url.hostname !== 'cdn.shopify.com' || !url.pathname.endsWith('.pdf')) return;
    event.preventDefault();
    if (link.getAttribute('aria-busy') === 'true') return;
    link.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(url.href, { mode: 'cors', credentials: 'omit' });
      if (!response.ok) throw new Error('PDF download unavailable');
      const blobUrl = URL.createObjectURL(await response.blob());
      const download = document.createElement('a');
      download.href = blobUrl;
      download.download = link.getAttribute('download') || decodeURIComponent(url.pathname.split('/').pop());
      document.body.appendChild(download);
      download.click();
      download.remove();
      setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
    } catch {
      window.location.assign(url.href);
    } finally {
      link.removeAttribute('aria-busy');
    }
  });
})();
